/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BasketsValidatePost400ResponseValidationErrorsInner from './BasketsValidatePost400ResponseValidationErrorsInner';

/**
 * The BasketsValidatePost400Response model module.
 * @module model/BasketsValidatePost400Response
 * @version 1.0.0
 */
class BasketsValidatePost400Response {
    /**
     * Constructs a new <code>BasketsValidatePost400Response</code>.
     * @alias module:model/BasketsValidatePost400Response
     */
    constructor() { 
        
        BasketsValidatePost400Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BasketsValidatePost400Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BasketsValidatePost400Response} obj Optional instance to populate.
     * @return {module:model/BasketsValidatePost400Response} The populated <code>BasketsValidatePost400Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BasketsValidatePost400Response();

            if (data.hasOwnProperty('error')) {
                obj['error'] = ApiClient.convertToType(data['error'], 'String');
            }
            if (data.hasOwnProperty('validationErrors')) {
                obj['validationErrors'] = ApiClient.convertToType(data['validationErrors'], [BasketsValidatePost400ResponseValidationErrorsInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BasketsValidatePost400Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BasketsValidatePost400Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['error'] && !(typeof data['error'] === 'string' || data['error'] instanceof String)) {
            throw new Error("Expected the field `error` to be a primitive type in the JSON string but got " + data['error']);
        }
        if (data['validationErrors']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['validationErrors'])) {
                throw new Error("Expected the field `validationErrors` to be an array in the JSON data but got " + data['validationErrors']);
            }
            // validate the optional field `validationErrors` (array)
            for (const item of data['validationErrors']) {
                BasketsValidatePost400ResponseValidationErrorsInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} error
 */
BasketsValidatePost400Response.prototype['error'] = undefined;

/**
 * @member {Array.<module:model/BasketsValidatePost400ResponseValidationErrorsInner>} validationErrors
 */
BasketsValidatePost400Response.prototype['validationErrors'] = undefined;






export default BasketsValidatePost400Response;

